import {
	ADMINMODULEALLOCATION_SUCCESS,
	ADMINMODULEALLOCATION_FAILED,
	RESET_ADMINMODULEALLOCATION,
	LOADING_ADMINMODULEALLOCATION,
	NETWORK_ERROR_ADMINMODULEALLOCATION
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminGetModuleAllocation = () => {
	return { type: RESET_ADMINMODULEALLOCATION };
};

const adminGetModuleAllocation = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINMODULEALLOCATION });
	await adminServices
		.post("getModuleAllocationList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetModuleAllocationsuccess(res.data));
					break;
				default:
					dispatch(adminGetModuleAllocationFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({ type: NETWORK_ERROR_ADMINMODULEALLOCATION, payload: err });
		});
};
function adminGetModuleAllocationsuccess(data) {
	return {
		type: ADMINMODULEALLOCATION_SUCCESS,
		payload: data
	};
}
function adminGetModuleAllocationFailed(data) {
	return {
		type: ADMINMODULEALLOCATION_FAILED,
		payload: data
	};
}

export { resetAdminGetModuleAllocation, adminGetModuleAllocation };
